import { createSlice, current } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const authSlice = createSlice({
	name: 'auth',
	initialState: {
		isAuthenticated: null,
		isSuperUser: false,
		isGroups: [],
		key: Cookies.get('bdKey'),
		refresh: Cookies.get('bdRef'),
		user: Cookies.get('bdUser') ? JSON.parse(Cookies.get('bdUser')) : false,
		shouldRefresh: false,
	},
	reducers: {
		setLogin(state, action) {
			const currState = state;
			const data = action.payload;
			const { refresh, access, user_data: user } = data;

			Cookies.set('bdRef', refresh, { expires: 1, secure: true, sameSite: 'Strict' });
			Cookies.set('bdKey', access, {
				expires: 1 / 4,
				secure: true,
				sameSite: 'Strict',
			});
			Cookies.set('bdUser', JSON.stringify(user), { expires: 1 / 4, secure: true, sameSite: 'Strict' });

			currState.key = access;
			currState.refresh = refresh;
			currState.user = user;
			currState.isGroups = user.privilegelevel_detail || [];
			currState.isAuthenticated = true;
		},
		setAuthenticated(state) {
			const currState = state;
			const objState = current(currState);

			if (objState.key && objState.user) {
				currState.isAuthenticated = true;
				// Ensure privilegelevel_detail exists, default to empty array if not
				currState.isGroups = objState.user.privilegelevel_detail || [];
				currState.isSuperUser = ['Developer', 'Administrasjon'].includes(objState.user.privilegelevelname);
			}
		},
		setLogout(state) {
			const currState = state;
			currState.key = false;
			currState.refresh = false;
			currState.user = false;
			currState.isAuthenticated = null;
			Cookies.remove('bdKey', { path: '/' });
			Cookies.remove('bdRef');
			Cookies.remove('bdUser');
		},
		setNewKeyValue(state, action) {
			const currState = state;
			const data = action.payload;
			const { key, value } = data;
			currState[key] = value;
		},
		setNewAuth(state, action) {
			const currState = state;
			const { refresh, access } = action.payload;
			currState.key = access;
			currState.refresh = refresh;
			Cookies.set('bdRef', refresh, { expires: 1, secure: true, sameSite: 'Strict' });
			Cookies.set('bdKey', access, {
				expires: 1 / 4,
				secure: true,
				sameSite: 'Strict',
			});
			currState.shouldRefresh = true;
		},
	},
});

export const authActions = authSlice.actions;
export default authSlice;
